import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TaskAssignmentApi ,TaskAssignmentSummary} from './TaskAssignmentApi';
import { FaArrowLeft, FaList, FaPlus, FaTasks, FaCheckCircle, FaHourglassHalf } from 'react-icons/fa';



export const TaskAssignmentDashboard: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const [summary, setSummary] = useState<{
    total: number;
    assigned: number;
    pending: number;
    completed: number;
  }>({
    total: 0,
    assigned: 0,
    pending: 0,
    completed: 0,
  });

  useEffect(() => {
    fetchSummary();
  }, []);

  const fetchSummary = async () => {
    setLoading(true);
    try {
      const response:TaskAssignmentSummary = await TaskAssignmentApi.getSummary(); // Make sure this endpoint exists
      setSummary({
        total: response.totalAssignments,
        assigned: response.overdueAssignments,
        pending: response.pendingAssignments,
        completed: response.completedAssignments,
      });
    } catch (err) {
      setError('Failed to load dashboard data');
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => navigate(-1);
  const handleList = () => navigate('/task-assignments/list');
  const handleCreate = () => navigate('/task-assignments/create');

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="mb-4 flex justify-between items-center">
        <div className="space-x-2">
          <button
            onClick={handleBack}
            className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center"
          >
            <FaArrowLeft className="mr-2" /> Back
          </button>
          <button
            onClick={handleList}
            className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded inline-flex items-center"
          >
            <FaList className="mr-2" /> Task Assignment List
          </button>
          <button
            onClick={handleCreate}
            className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded inline-flex items-center"
          >
            <FaPlus className="mr-2" /> Create Task Assignment
          </button>
        </div>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="text-red-500">{error}</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
          <div className="bg-white shadow rounded-xl p-6 text-center border-l-4 border-blue-500">
            <FaTasks className="text-3xl mx-auto text-blue-500 mb-2" />
            <p className="text-gray-700 font-semibold">Total Assignments</p>
            <p className="text-2xl font-bold">{summary.total}</p>
          </div>

          <div className="bg-white shadow rounded-xl p-6 text-center border-l-4 border-yellow-500">
            <FaHourglassHalf className="text-3xl mx-auto text-yellow-500 mb-2" />
            <p className="text-gray-700 font-semibold">Pending</p>
            <p className="text-2xl font-bold">{summary.pending}</p>
          </div>

          <div className="bg-white shadow rounded-xl p-6 text-center border-l-4 border-green-500">
            <FaCheckCircle className="text-3xl mx-auto text-green-500 mb-2" />
            <p className="text-gray-700 font-semibold">Completed</p>
            <p className="text-2xl font-bold">{summary.completed}</p>
          </div>

          <div className="bg-white shadow rounded-xl p-6 text-center border-l-4 border-purple-500">
            <FaTasks className="text-3xl mx-auto text-purple-500 mb-2" />
            <p className="text-gray-700 font-semibold">Assigned</p>
            <p className="text-2xl font-bold">{summary.assigned}</p>
          </div>
        </div>
      )}
    </div>
  );
};